import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberStatusForm from '../../../components/forms/MemberStatusForm';
import { useMemberStatusById, useUpdateMemberStatus } from '../../../hooks/useMemberStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberStatusDTO } from '../../../services/apiClient';

const MemberStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberStatusById(id!);
  const updateMutation = useUpdateMemberStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Statuses', href: '/admin/memberstatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberstatuses');
    } catch (error) {
      console.error('Error updating MemberStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberStatus.Edit"
    >
        {entityData ? (
          <MemberStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberStatusEdit;
